<template>
  <div
    class="container"
    data-testid="settings-cloud-tab-disabled"
  >
    <div class="content">
      <div class="left">
        <h2
          class="ibf-h2 app_text_grey q-pb-md"
          data-testid="settings-cloud-tab-disabled--title"
        >
          {{ $t('settings.cloud.cloudDisabled.title') }}
        </h2>
        <div data-testid="settings-cloud-tab-disabled--description">
          <p class="app_text_grey ibf-oneline1">{{ $t('settings.cloud.cloudDisabled.body.p1') }}</p>
          <p class="app_text_grey ibf-oneline1">{{ $t('settings.cloud.cloudDisabled.body.p2') }}</p>
        </div>
        <div class="links">
          <IncrediButton
            :disabled="!userRolePermissions.authorize?.value?.settings.enabled.cloud"
            class="scale-btn w-full justify-center"
            design="primary-purple"
            size="small"
            :rounded="true"
            data-testid="settings-cloud-tab-disabled--add-cloud-helpers-button"
            @click.prevent="scaleToCloud"
          >
            <div class="flex justify-center items-center">
              <i class="cloud-icon incredicon-add-cloud w-[22px]" />
              <span>{{ $t('settings.cloud.cloudDisabled.button') }}</span>
            </div>
          </IncrediButton>
          <div
            class="inline row justify-between"
            style="width: 196px"
          >
            <a
              data-testid="settings-cloud-tab-disabled--learn-more"
              :href="salesSiteUrl"
              target="_blank"
              >{{ $t('settings.cloud.cloudDisabled.learnMoreLink') }}</a
            >
            <a
              data-testid="settings-cloud-tab-disabled--contact-sales"
              :href="salesMailUrl"
              >{{ $t('settings.cloud.cloudDisabled.contactSalesLink') }}</a
            >
          </div>
        </div>
      </div>
      <div class="right">
        <img
          data-testid="settings-cloud-tab-disabled--image"
          src="@/assets/images/settings/cloud/cloud-trial.svg"
          alt="14 Days Trial"
          width="150"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { IncrediButton } from 'incredi-ui';

export default {
  name: 'CloudDisabled',
  components: { IncrediButton },
  model: {
    events: ['scaleToCloud'],
  },
  setup() {
    const userRolePermissions = useUserRolePermissions();
    return {
      userRolePermissions,
    };
  },
  data() {
    return {
      salesMailUrl: process.env.VUE_APP_CLOUD_SALES_MAIL,
      salesSiteUrl: process.env.VUE_APP_CLOUD_SALES_SITE_URL,
    };
  },
  computed: {
    ...mapGetters({
      token: ['session/getAccessToken'],
    }),
  },
  methods: {
    scaleToCloud() {
      this.$emit('scaleToCloud');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & .content {
    width: 840px;
    height: 346px;
    background-color: $-system-app-background;
    padding: 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  & .right {
    width: 300px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .left {
    display: flex;
    flex-direction: column;
    width: 450px;
    height: 100%;
    .cloud-icon {
      &::before {
        margin: 0;
      }
    }
    h2 {
      line-height: 30px;
      margin: 0;
    }

    & .scale-btn {
      width: 200px;
    }

    & .links {
      gap: 16px;
      flex-direction: column;
      font-size: 11px;
      display: inline-flex;
      justify-content: space-between;

      & a:link,
      & a:visited {
        color: $-text-text-low-old;
        transition: 0.2s;
      }

      & a:hover,
      & a:active {
        color: $-text--dark;
        transition: 0.2s;
      }
    }
  }
}
</style>
